// src/pages/ClientViewLayout.js
import React from "react";
import { Container, Nav } from "react-bootstrap";
import { NavLink, Outlet, useParams } from "react-router-dom";

export default function ClientViewLayout() {
  const { id } = useParams();

  const tabs = [
    // Dashboard is the INDEX route of /clients/:id/view
    { key: "dashboard", label: "Client Dashboard", to: `/clients/${id}/view` },

    { key: "demographics", label: "Demographics", to: `/clients/${id}/view/demographics` },
    { key: "employment", label: "Employment", to: `/clients/${id}/view/employment` },
    { key: "financials", label: "Financials", to: `/clients/${id}/view/financials` },
    { key: "health", label: "Health", to: `/clients/${id}/view/health` },
    { key: "intakeSummary", label: "Intake Summary", to: `/clients/${id}/view/intake-summary` },
  ];

  return (
    <Container fluid className="p-3">
      <Nav variant="tabs" className="mb-3">
        {tabs.map((t) => (
          <Nav.Item key={t.key}>
            <Nav.Link as={NavLink} to={t.to} end={t.key === "dashboard"}>
              {t.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <Outlet />
    </Container>
  );
}
